import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import PackageType from '../entities/packageType'

import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'


interface PackageTypeState extends ListState<PackageType>{
    packageType:PackageType
    editPackageType:PackageType

}

class PackageTypeMutations extends ListMutations<PackageType>{

}

class PackageTypeModule extends ListModule<PackageTypeState,any,PackageType>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<PackageType>(),
        loading:false,
        editPackageType:new PackageType(),
        selectPackageType:new PackageType(),
      
    
    
    }
    actions={

        async selectPackageType(context:ActionContext<PackageTypeState,any>,payload:any){
            context.state.editPackageType=payload.data;
        },

        async deletePackageType(context:ActionContext<PackageTypeState,any>,payload:any){

            await Ajax.delete('/api/services/app/Definition/DeletePackageType?input='+payload.data);
        },
     
        async savePackageType(context:ActionContext<PackageTypeState,any>,payload:any){
         
        
            let reponse=await Ajax.post('/api/services/app/Definition/SavePackageType',payload.data);
          
            let page=reponse.data.result as PageResult<PackageType>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async updatePackageType(context:ActionContext<PackageTypeState,any>,payload:any){
         
        
            let reponse=await Ajax.put('/api/services/app/Definition/UpdatePackageType',payload.data);
          
            let page=reponse.data.result as PageResult<PackageType>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getPackageTypes(context:ActionContext<PackageTypeState,any>,payload:any){
          
           // context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Definition/GetPackageTypes',payload.data);
          
           // context.state.loading=false;
            let page=reponse.data.result as PageResult<PackageType>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
       
     
   
 
    };
    mutations={
        setCurrentPage(state:PackageTypeState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:PackageTypeState,pagesize:number){
            state.pageSize=pagesize;
        },
       
    }
}
const packageTypeModule=new PackageTypeModule();
export default packageTypeModule;